
export const addPost = ({ dispatch }, text) => {
	console.log(text)
	dispatch("ADD_POST", {
      text: text.text
    })
}



// WEBPACK FOOTER //
// ./src/store/actions.js